import * as React from "react";
import Chart from "react-apexcharts";
import { Typography, Alert } from "@mui/material";
import { useEffect, useState } from "react";
import { AlertModel } from "../Internalcomponents/AlertModel";

export const Barchart = ({ dates, values, error }) => {

    const [categories, setCategories] = useState([]);
    const [series, setSeries] = useState([{
        name: 'Data',
        data: []
    }]);
    const [chartKey, setChartKey] = useState(0);


    useEffect(() => {
        // API call to fetch chart data
        console.log("dates in values : ", dates)
        if (Array.isArray(values) && values.length > 0) {
            setSeries([{ name: "Data", data: values }]);
            setChartKey(prevKey => prevKey + 1);
        }


    }, [values]);

    useEffect(() => {
        console.log("dates in dates : ", dates)
        if (Array.isArray(dates) && dates.length > 0) {
            setCategories(dates);
        }

    }, [dates]);

    const options = {
        chart: {
            id: "basic-bar",
            // background: '#f5f5f5',
        },
        title: {
            // text: 'Execution History'
        },
        grid: {
            show: false,      // you can either change hear to disable all grids 
        },
        xaxis: {
            categories: categories,
        },
        plotOptions: {
            bar: {
                borderRadiusApplication: 'end',
                borderRadius: 15, // Adjust this value to increase or decrease the radius
                horizontal: false,
                columnWidth: '40%',

            }
        },
        fill: {
            type: 'gradient',
            gradient: {
                type: 'vertical',
                colorStops: [
                    {
                        offset: 0,
                        color: '#4419FF',
                        opacity: 1
                    },
                    {
                        offset: 50,
                        color: '#4419FF',
                        opacity: 0.7
                    },
                    {
                        offset: 140,
                        color: '#4419FF',
                        opacity: 0.3
                    }
                ]
            }
        }
    };



    return (
        <>
        
            <Typography style={{ fontWeight: "bold", fontSize: " 0.9375rem", fontFamily: "DM Sans, sans-serif" }}> Execution History </Typography>
            { error ? <AlertModel message="error" /> : 
            series[0].data.length > 0 && categories.length > 0 && (<Chart key={chartKey}
                options={options}
                series={series}

                type="bar"
                width={"100%"}
                height={"100%"}
            />
            )}
            


        </>
    );
}